"use strict";

export function ucFirst() {
  return function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}

export function priceDollar() {
  return function(price) {
    price = price.toString();
    if (price.indexOf('.') < 0)
      return price;

    return price.split('.')[0];
  }
};

export function priceCents() {
  return function(price) {
    price = price.toString();
    if (price.indexOf('.') < 0)
      return price;
    return price.split('.')[1];
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/filters/global.js